import * as React from 'react';

interface Props {
    children: (toggle: boolean, setToggle: () => void) => JSX.Element;
}

export default function ToggleComponents({ children }: Props) {
    const [toggle, setToggle] = React.useState<boolean>(false);

    const handleSetToggle = () => setToggle(toggle => !toggle);

    return children(toggle, handleSetToggle);
}
